export default "__VITE_ASSET__CWijLjcs__"